import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query';

import { redirectsApi, type RedirectListParams } from '../api/redirects-api';

import { redirectKeys } from './redirect-keys';

/** Shared by the route loader (prefetch) and the page hook (subscribe). */
export function redirectListQueryOptions(storeId: string, params: RedirectListParams) {
  return queryOptions({
    queryKey: redirectKeys.list(storeId, params),
    queryFn: () => redirectsApi.list(storeId, params),
    placeholderData: keepPreviousData,
  });
}

export function useRedirects(storeId: string, params: RedirectListParams) {
  return useQuery(redirectListQueryOptions(storeId, params));
}
